export default {
	ME: () => `/me`,
	USER_VIDEOS: () => `/user-videos`,
	CHAT_SENTIMENT_LIVE: (sessionId) => `/chat-sentiment-live/${sessionId}`,
	CHAT_SENTIMENT_LIVE_SESSION: () => `/chat-sentiment-live-session`,

	// Auth
	AUTH_TWITCH_REDIRECT: () => `/oauth/twitch/redirect`,
}